import React from 'react';
import { Button } from '@mui/material';

function ServicesButton(props) {
  const { clickAction, sx = {} } = props;

    return (
      <Button
        variant="contained"
        color="primary"
        id='services-button'
        sx={{
          marginLeft: {xxs: '0px', xs :'20px'},
          marginTop: '-5px',
          borderRadius: '40px',
          height: '30px',
          ...sx,
        }}
        onClick={() => {
          if (clickAction) {
            clickAction();
          }
        }}
      >
        Publish
      </Button>
    );
}

export default ServicesButton;
